<template>
    <div class="ModalMarketing">
        <template v-if="lstModalMarketing != []">
            <template v-for="(item,id) in lstModalMarketing">
                <transition :name="item.tipoModal+'-slide'" :key="id">                    
                    <section :class="'aviso '+item.tipoModal" v-if="item.show">
                        <div>
                            <button type="button" class="close c-pointer" @click="item.show = false"><span>&times;</span></button>
                            <div v-html="item.htmModal"></div>
                        </div>
                    </section>
                </transition>
            </template>
        </template>
        
        
        
    </div>
</template>

<script>
    import { urlApi } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'ModalMarketing',
        data: function () {
            return {
                lstModalMarketing: [],

                tempoParaSurgirModais: 2000,
                tpModal: (this.user != null ? 'Logado' : 'Deslogado'),
                teste: false,
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },
        },
        methods: {

            load() {
                this.carregaModalMarketing();
            },

            carregaModalMarketing() {
                let $this = this;
                axios.get(`${urlApi}/Marketing/CarregaModalMarketing`, { params: { p_flExibeLogado: $this.tpModal } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstModalMarketing = [];
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    var item = res.data.data.rows[i];

                                    var tipoModal = "aviso-";
                                    if (item.tpModal == "Rodapé" && item != null) {
                                        tipoModal += "rodape";
                                        item.tpModal = "Rodape";
                                    }
                                    else if (item.tpModal == "Lateral" && item != null) {
                                        tipoModal += "lateral";
                                    }
                                    else if (item.tpModal == "Centro" && item != null) {
                                        tipoModal += "centro";
                                    }
                                    else if (item.tpModal == "Topo" && item != null) {
                                        tipoModal += "topo";
                                    }
                                    else if (item.tpModal == "Tela toda" && item != null) {
                                        tipoModal += "tela-toda";
                                    }
                                    item.show = false;
                                    item.tipoModal = tipoModal;

                                    if ($this.lstModalMarketing.length == 0 && localStorage.getItem("idMarketingModal-" + item.tpModal) == null) {
                                        $this.lstModalMarketing.push(item);
                                        $this.confirmaStorageMarketingModal(item.idModal, item.tpModal, $this.tpModal);
                                        $this.tempoParaSurgirModais += (item.nrTempoAparecer * 1000);
                                    }
                                }
                            }
                        } else {
                            $this.lstModalMarketing = [];
                        }
                    })
                    .catch(function () {
                        $this.lstModalMarketing = [];
                    });
            },

            confirmaStorageMarketingModal(idModal, tpModal, tpModalLogado) {
                var $this = this;
                // exibir depois de quantos dias?
                var numeroDiasAdd = 0;
                if (tpModalLogado == 'Logado') {
                    numeroDiasAdd = 3;
                }
                else {
                    numeroDiasAdd = 1;
                }

                // variáveis de data
                var momentHoje, momentFuturo;
                momentHoje = moment().format('DD/MM/YYYY');
                momentFuturo = moment().add(numeroDiasAdd, "days").format('DD/MM/YYYY');

                // verifica se existe alguma data guardada
                var dataGuardada = localStorage.getItem("popupMarketingModalTime-" + tpModal);

                //verifica se tem um id de modal
                var idMarketingModal = localStorage.getItem("idMarketingModal-" + tpModal);

                // se sim
                if (dataGuardada !== null || idMarketingModal !== null) {
                    // verifica se já passou tempo suficiente desde a última exibição

                    if (moment(momentHoje, "DD/MM/YYYY").diff(moment(dataGuardada, "DD/MM/YYYY"), 'days') >= 0) {
                        // Mostrar pop-up
                        setTimeout(function () {
                            $this.show(idModal);
                        }, $this.tempoParaSurgirModais);

                        // Atualizar a data e o id no localstorage
                        localStorage.setItem("popupMarketingModalTime-" + tpModal, momentFuturo);
                        localStorage.setItem("idMarketingModal-" + tpModal, idModal);
                    } else {
                        // remove
                        $this.lstModalMarketing = $this.lstModalMarketing.filter(function (i) { return i.idModal != idModal });
                    }
                } else {
                    // a pop-up nunca foi mostrada antes, então vamos criar a data e o id
                    localStorage.setItem("popupMarketingModalTime-" + tpModal, momentFuturo);
                    localStorage.setItem("idMarketingModal-" + tpModal, idModal);

                    // Mostrar pop-up
                    setTimeout(function () {
                        $this.show(idModal);
                    }, $this.tempoParaSurgirModais);
                }
            },

            gravaLogMarketingModalView(idModal) {
                console.log(idModal);
            },

            show(idModal) {

                if (this.lstModalMarketing.length > 0) {
                    var modal = this.lstModalMarketing.find(x => x.idModal == idModal);
                    if (modal.tipoModal == "aviso-rodape") {
                        setTimeout(function () {
                            //$(`.${modal[0]}`).animate({
                            //    opacity: 1,
                            //    bottom: '0'
                            //}, 1000).show();

                            modal.show = true;

                        }, modal.nrTempoAparecer * 1000);
                    } else if (modal.tipoModal == "aviso-topo") {
                        setTimeout(function () {
                            //$(`.${modal[0]}`).animate({
                            //    opacity: 1,
                            //    top: '0'
                            //}, 1000).show();

                            modal.show = true;
                        }, modal.nrTempoAparecer * 1000);
                    } else if (modal.tipoModal == "aviso-lateral") {
                        setTimeout(function () {
                            //$(`.${modal[0]}`).animate({
                            //    opacity: 1,
                            //    right: '0'
                            //}, 1000).show();

                            modal.show = true;
                        }, modal.nrTempoAparecer* 1000);
                    } else if (modal.tipoModal == "aviso-tela-toda") {
                        setTimeout(function () {
                            //$(".aviso-tela-toda").fadeIn();

                            modal.show = true;
                        }, modal.nrTempoAparecer * 1000);
                    } else {
                        setTimeout(function () {
                            //$(".aviso-centro").fadeIn();

                            modal.show = true;
                        }, modal.nrTempoAparecer * 1000);
                    }
                }
            }

        },
        created: function () {
            this.load();
        },
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* ModalTransmissao */
    .aviso {
        box-shadow: 0 0 10px 5px rgba(0,0,0,0.3);
    }

        .aviso img {
            margin: 0 auto;
        }

    .slide-capa .carousel-caption {
        z-index: 1;
    }

    .aviso .close {
        text-shadow: 0 1px 0 #FFF !important;
        font-size: 30px !important;
        background-color: #f7ca4d !important;
        width: 40px;
        height: 40px;
        margin: 0;
        padding: 0 0 4px 0;
        line-height: 30px;
        position: absolute;
        top: 0;
        right: 0;
        opacity: 1;
    }

        .aviso .close:hover {
            opacity: .9;
        }

        .aviso .close span {
            color: #fff !important;
        }

    .aviso.aviso-rodape, .aviso.aviso-lateral, .aviso.aviso-centro, .aviso.aviso-topo {
        position: fixed;
        z-index: 1001;
    }

    .aviso-rodape {
        /*opacity: 0;*/
        /*bottom: -150px;*/
        bottom: 0;
        left: 0;
        right: 0;
    }

    .aviso-topo {
        /*opacity: 0;*/
        /*top: -100px;*/
        top: 0;
        margin: auto;
        width: 480px;
        left: 0;
        right: 0;
        max-width: 100%;
    }

    .aviso-lateral {
        /*opacity: 0;*/
        bottom: 30vh;
        max-height: 250px;
        top: 30vh;
        /*right: -400px;*/
        right: 0;
        z-index: 2;
        width: 400px;
        max-width: 100%;
    }

    .aviso-centro {
        display: none;
        top: 0;
        left: 0;
        right: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(51, 51, 51, 0.5);
    }

        .aviso-centro > div {
            width: 600px;
            max-width: 100%;
            top: 54px;
            margin: 0 auto;
            position: relative;
        }

        .aviso-centro img {
            width: 600px;
        }

    .aviso-tela-toda {
        display: none;
        top: 0;
        left: 0;
        right: 0;
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 9999;
        background: rgba(51, 51, 51, 0.5);
    }

        .aviso-tela-toda > div {
            width: 100%;
            max-width: 100%;
            top: 0;
            margin: 0 auto;
            position: relative;
        }

        .aviso-tela-toda img {
            display: block;
            margin-left: auto;
            margin-right: auto;
            margin-top: 64px;
            width: 50%;
        }


    /*  ANIMAÇÕES   */

    @keyframes aviso-rodape-slide-in{
        from { transform: translateY(-150px); }
        to { transform: translateY(0); }
    }

    @keyframes aviso-rodape-slide-out{
        from { transform: translateY(0); }
        to { transform: translateY(-150px); }
    }

    .aviso-rodape-slide-enter, .aviso-rodape-slide-leaver-to {
        opacity: 0;
    }

    .aviso-rodape-slide-enter-active {
        transition: opacity 2s;
        animation: slide-down-in 2s ease;
    }
    
    .aviso-rodape-slide-leave-active {
        transition: opacity 2s;
        animation: slide-down-out 2s ease;
    }
    .aviso-rodape-slide-enter-to, .aviso-rodape-slide-leave {
        opacity: 1;
    }

    @keyframes aviso-topo-slide-in{
        from { transform: translateY(-100px); }
        to { transform: translateY(0); }
    }

    @keyframes aviso-topo-slide-out{
        from { transform: translateY(0); }
        to { transform: translateY(-100px); }
    }

    .aviso-topo-slide-enter, .aviso-topo-slide-leaver-to {
        opacity: 0;
    }

    .aviso-topo-slide-enter-active {
        transition: opacity 2s;
        animation: slide-down-in 2s ease;
    }
    
    .aviso-topo-slide-leave-active {
        transition: opacity 2s;
        animation: slide-down-out 2s ease;
    }
    .aviso-topo-slide-enter-to, .aviso-topo-slide-leave {
        opacity: 1;
    }


    @keyframes aviso-lateral-slide-in{
        from { transform: translateX(-400px); }
        to { transform: translateX(0); }
    }

    @keyframes aviso-lateral-slide-out{
        from { transform: translateX(0); }
        to { transform: translateX(-400px); }
    }

    .aviso-lateral-slide-enter, .aviso-lateral-slide-leaver-to {
        opacity: 0;
    }

    .aviso-lateral-slide-enter-active {
        transition: opacity 2s;
        animation: slide-down-in 2s ease;
    }
    
    .aviso-lateral-slide-leave-active {
        transition: opacity 2s;
        animation: slide-down-out 2s ease;
    }
    .aviso-lateral-slide-enter-to, .aviso-lateral-slide-leave {
        opacity: 1;
    }

    

    .aviso-tela-toda-slide-enter, .aviso-tela-toda-slide-leaver-to {
        opacity: 0;
    }

    .aviso-tela-toda-slide-enter-active {
        transition: opacity 2s;
    }

    .aviso-tela-toda-slide-leave-active {
        transition: opacity 2s;
    }

   /* .aviso-tela-toda-slide-enter-to, .aviso-tela-toda-slide-leave {
        opacity: 1;
    }*/


</style>

